import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-41b390c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "address-list"
};
const _hoisted_2 = {
  class: "ul"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "user"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "tel"
};
const _hoisted_9 = {
  key: 0,
  class: "default"
};
const _hoisted_10 = {
  class: "user_address"
};
const _hoisted_11 = {
  class: "btn-box"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "是否确认删除该地址", -1));
const _hoisted_13 = {
  class: "bt-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "li",
      onClick: $event => $options.editOrderAddress(item),
      key: item.id
    }, [_createElementVNode("div", {
      class: "close",
      onClick: _withModifiers($event => $options.close(item), ["stop"])
    }, null, 8, _hoisted_4), _createElementVNode("div", {
      class: "edit",
      onClick: _withModifiers($event => $options.edit(item), ["stop"])
    }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.address_name), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.address_mobile), 1), item.is_default ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.province) + " " + _toDisplayString(item.city) + " " + _toDisplayString(item.county) + " " + _toDisplayString(item.street) + " " + _toDisplayString(item.address), 1)], 8, _hoisted_3);
  }), 128))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("button", {
    class: "frombtn",
    round: "",
    block: "",
    type: "primary",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.add && $options.add(...args)),
    "native-type": "submit"
  }, " 新建地址 ")]), _createVNode(_component_van_overlay, {
    show: $data.dialogShow,
    onClick: _cache[4] || (_cache[4] = $event => $data.dialogShow = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "dialog",
      onClick: _cache[3] || (_cache[3] = _withModifiers($event => $data.dialogShow = true, ["stop"]))
    }, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
      class: "bt",
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.deleteItem && $options.deleteItem(...args), ["stop"]))
    }, "确认"), _createElementVNode("div", {
      class: "bt",
      onClick: _cache[2] || (_cache[2] = _withModifiers($event => $data.dialogShow = false, ["stop"]))
    }, "取消")])])]),
    _: 1
  }, 8, ["show"])]);
}